<div class="zoom-fit-container" (click)="$event.stopPropagation()">
  <div (click)="triggersService.fitToScreen.next()"
       [dsTooltip]="'text_fitToScreen' | dbText"
       class="controller"
       dsTooltipColor="black"
       dsTooltipPosition="top"
       dsTooltipSize="small">
    <i class="db-icon db-icon-ds-zoom-to-fit"></i>
  </div>
</div>
